document.addEventListener("DOMContentLoaded", () => {
	const scrollToTopButton = document.querySelector(".button__back-to-top");

	scrollToTopButton.addEventListener("click", () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});
});
